import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

const FieldTooltip = ({ fieldName, description }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="relative inline-block ml-1">
      <button
        type="button"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={() => setShow(!show)}
        className="text-slate-400 hover:text-slate-600 transition-colors"
      >
        <HelpCircle className="h-4 w-4" />
      </button>
      
      {show && (
        <div className="absolute left-0 top-6 z-50 w-64 p-3 bg-slate-900 text-white text-xs rounded-lg shadow-xl">
          <div className="font-semibold mb-1">{fieldName}</div>
          <div className="text-slate-300 leading-relaxed">{description}</div>
          <div className="absolute -top-1 left-2 w-2 h-2 bg-slate-900 transform rotate-45"></div>
        </div>
      )}
    </div>
  );
};

export default FieldTooltip;
